import MuiSnackbar from "@mui/material/Snackbar"
import MuiAlert from "@mui/material/Alert"

export interface SnackbarState {
  type: "success" | "error" | "warning"
  text: string | JSX.Element
  show: boolean
}

export const Snackbar = ({ snackbarData, setSnackbarData }) => {
  return (
    <MuiSnackbar
      open={snackbarData.show}
      autoHideDuration={6000}
      onClose={() => {
        setSnackbarData({ ...snackbarData, show: false })
      }}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={() => {
          setSnackbarData({ ...snackbarData, show: false })
        }}
        severity={snackbarData.type}
        sx={{ width: "100%" }}
      >
        {snackbarData.text}
      </MuiAlert>
    </MuiSnackbar>
  )
}
